import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

import { TranslateDirective } from '@speedy/core';

import { CurrencyComponent } from '../../../../../../shared/components/currency/currency.component';
import { CalculatorService } from '../../../services/calculator.service';

export interface LHVLoan {
  advance: number;
  interest: number;
  period: number;
  price: number;
  getMonthlyPayment: () => any;
  priceBasedInterest: boolean;
}

declare const LHV: any;

@Component({
  selector: 'app-lhv-calculator',
  templateUrl: './lhv-calculator.component.html',
  styleUrls: ['./lhv-calculator.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TranslateDirective,
    ReactiveFormsModule,
    FormsModule,
    CurrencyComponent,
    MatProgressSpinner,
  ],
})
export class LhvCalculatorComponent implements OnInit {
  @Input() productPrice!: number;

  interestRate = 8.9;
  loan: LHVLoan;
  loanPeriod = 6;
  loanPeriods = [6, 12, 18, 24, 30, 36, 42, 48];
  monthlyPayment!: number;

  loadingPayment = false;

  constructor(
    protected calculatorService: CalculatorService,
    protected alertService: ToastrService,
  ) {
    this.loan = new LHV.hirePurchase();
  }

  ngOnInit() {
    this.changePeriod(this.loanPeriod);
  }

  public changePeriod(period: number) {
    this.loadingPayment = true;
    this.loan = new LHV.hirePurchase();
    this.loan.interest = this.interestRate;
    this.loan.price = this.productPrice;
    this.loan.period = period;
    this.loan.priceBasedInterest = true;

    const response = this.loan.getMonthlyPayment();

    if (response.error) {
      this.alertService.error(response.error);
      this.loadingPayment = false;
    } else {
      this.monthlyPayment = response.payment;
      this.loadingPayment = false;
    }
  }
}
